import { useState } from "react";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 25,
  sort: "-created_at",
};

const useQuery = ({ defaultQuery = DEFAULT_QUERY }) => {
  if (!defaultQuery) throw new Error("defaultQuery is required");
  const [query, setQuery] = useState(defaultQuery);
  const { search, page, limit, sort } = query;

  const handleLimitChange = (e) => {
    const { value } = e.target.dataset;

    setQuery({ ...query, limit: +value });
  };

  const handlePageChange = (page) => {
    setQuery({ ...query, page });
  };

  const handleSearch = (searchText) => {
    console.log(searchText, search);
    if (searchText !== search) setQuery({ ...query, search: searchText });
  };

  const handleSort = (columnId) => {
    // Implement sorting logic for the column
    sort === columnId
      ? setQuery({ ...query, sort: `-${columnId}` })
      : setQuery({ ...query, sort: columnId });
  };

  return {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  };
};

export default useQuery;
